import React from "react"

import {
	ErrorConfig,
	ErrorResponse,
	ErrorType,
	RestErrorDialog,
	RestResponse,
} from "@sinossi/mates-react-library"

// import { AuthenticationService } from "services/authentication.service"
import { StorebookErrorService } from "services/error.service"
import { UseRouterParams } from "services/router"

export type OnErrorCallback = (
	details: { [id: string]: string } | null,
	response: RestResponse<any, ErrorResponse>
) => void
export interface MatesComponentCallback {
	onErrorCallback: OnErrorCallback
}
export interface MatesComponentState {
	loading: boolean
	errorDialog: {
		open: boolean
		title: string
		message: string
	}
	response: RestResponse<any, ErrorResponse> | null
	errorConfig: ErrorConfig
	openHttpError: boolean
}
export class MatesComponent<P extends UseRouterParams, S extends MatesComponentState> {
	private readonly errorService: StorebookErrorService = StorebookErrorService.init()

	private readonly component: React.Component<P, S>

	private readonly onErrorCallback: OnErrorCallback | null

	constructor(component: React.Component<P, S>, onErrorCallback: OnErrorCallback | null = null) {
		this.component = component
		this.onErrorCallback = onErrorCallback
	}

	public setupState(): MatesComponentState {
		return {
			loading: false,
			errorDialog: {
				open: false,
				title: "",
				message: "",
			},
			response: null,
			errorConfig: StorebookErrorService.defaultErrorConfig,
			openHttpError: false,
		}
	}

	public onException = (response: RestResponse<any, ErrorResponse>) => {
		if (response instanceof RestResponse) {
			if (response.hasError() && response.status() === 401) {
				// this.authenticationService.logout()
				// TODO: force logout
				return
			}
		}

		this.component.setState(() => ({
			loading: false,
			response: response,
			openHttpError: true,
		}))
	}

	public onError = (response: RestResponse<any, ErrorResponse>): void => {
		const errorType: ErrorType = this.errorService.getErrorType(response)
		switch (errorType) {
			case ErrorType.MESSAGE:
			case ErrorType.HTTP_ERROR:
			case ErrorType.UNKNOWN:
				this.onException(response)
				break
			case ErrorType.CALLBACK:
				this.onErrorCallback?.(response.error!.details ?? null, response)
				break
			case ErrorType.REDIRECT:
				const endpoint: string = this.errorService.getRedirectEndpoint(response) ?? "/"
				const { navigate } = this.component.props
				navigate(endpoint)
				break
		}
	}

	private closeHttpErrorModal = (): void => {
		this.component.setState(() => ({
			openHttpError: false,
			response: null,
		}))
	}

	public render(): React.ReactNode {
		return (
			<RestErrorDialog
				open={this.component.state.openHttpError}
				response={this.component.state.response}
				ok={this.closeHttpErrorModal}
				errorParser={this.errorService.parseErrorCode}
				{...this.component.state.errorConfig}
			/>
		)
	}
}
